// Generated by Melange

import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_link from "./buhta_kassa_v1alpha1_etp_link.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt from "./buhta_kassa_v1alpha1_receipt.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_data from "./buhta_kassa_v1alpha1_receipt_data.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_struct from "../../third_party/google_wkt/gen/google_protobuf_struct.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const CreateEtpReceiptRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_etp_receipt_service.ml",
  752,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const CreateEtpReceiptResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_etp_receipt_service.ml",
  837,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const GetEtpOrderRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_etp_receipt_service.ml",
  900,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const GetEtpOrderResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_etp_receipt_service.ml",
  969,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const EtpOrder = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_etp_receipt_service.ml",
  1032,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const EtpReceipt = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_etp_receipt_service.ml",
  1104,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.kassa.v1alpha1.CreateEtpReceiptRequest";
}

function make(tin, org_id, kkm_id, order_numOpt, receipt, async, route, tag, metadata, param) {
  const order_num = order_numOpt !== undefined ? order_numOpt : "";
  return {
    tin: tin,
    org_id: org_id,
    kkm_id: kkm_id,
    order_num: order_num,
    receipt: receipt,
    async: async,
    route: route,
    tag: tag,
    metadata: metadata
  };
}

const merge_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "tin",
    "tin"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const merge_org_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "org_id",
    "orgId"
  ],
  Ocaml_protoc_plugin__Spec.int32_int
]));

const merge_kkm_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    3,
    "kkm_id",
    "kkmId"
  ],
  Ocaml_protoc_plugin__Spec.int32_int
]));

const merge_order_num = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "order_num",
    "orderNum"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_data.Buhta.Kassa.V1alpha1.ReceiptData;

const merge_receipt = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    5,
    "receipt",
    "receipt"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let.name,
    make: $$let.make,
    from_proto: $$let.from_proto,
    from_proto_exn: $$let.from_proto_exn,
    to_proto: $$let.to_proto,
    to_proto$p: $$let.to_proto$p,
    merge: $$let.merge,
    to_json: $$let.to_json,
    from_json_exn: $$let.from_json_exn,
    from_json: $$let.from_json
  })
]));

const merge_async = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    6,
    "async",
    "async"
  ],
  Ocaml_protoc_plugin__Spec.bool
]));

const merge_route = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    7,
    "route",
    "route"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const merge_tag = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    8,
    "tag",
    "tag"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const $$let$1 = Google_wkt__Google_protobuf_struct.Google.Protobuf.Struct;

const merge_metadata = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    9,
    "metadata",
    "metadata"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$1.name,
    make: $$let$1.make,
    from_proto: $$let$1.from_proto,
    from_proto_exn: $$let$1.from_proto_exn,
    to_proto: $$let$1.to_proto,
    to_proto$p: $$let$1.to_proto$p,
    merge: $$let$1.merge,
    to_json: $$let$1.to_json,
    from_json_exn: $$let$1.from_json_exn,
    from_json: $$let$1.from_json
  })
]));

function merge(t1, t2) {
  return {
    tin: Curry._2(merge_tin, t1.tin, t2.tin),
    org_id: Curry._2(merge_org_id, t1.org_id, t2.org_id),
    kkm_id: Curry._2(merge_kkm_id, t1.kkm_id, t2.kkm_id),
    order_num: Curry._2(merge_order_num, t1.order_num, t2.order_num),
    receipt: Curry._2(merge_receipt, t1.receipt, t2.receipt),
    async: Curry._2(merge_async, t1.async, t2.async),
    route: Curry._2(merge_route, t1.route, t2.route),
    tag: Curry._2(merge_tag, t1.tag, t2.tag),
    metadata: Curry._2(merge_metadata, t1.metadata, t2.metadata)
  };
}

function spec(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt_data.Buhta.Kassa.V1alpha1.ReceiptData;
  const $$let$1 = Google_wkt__Google_protobuf_struct.Google.Protobuf.Struct;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "tin",
      "tin"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "org_id",
      "orgId"
    ],
    Ocaml_protoc_plugin__Spec.int32_int
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      3,
      "kkm_id",
      "kkmId"
    ],
    Ocaml_protoc_plugin__Spec.int32_int
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "order_num",
      "orderNum"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      5,
      "receipt",
      "receipt"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      6,
      "async",
      "async"
    ],
    Ocaml_protoc_plugin__Spec.bool
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      7,
      "route",
      "route"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      8,
      "tag",
      "tag"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      9,
      "metadata",
      "metadata"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let$1.name,
      make: $$let$1.make,
      from_proto: $$let$1.from_proto,
      from_proto_exn: $$let$1.from_proto_exn,
      to_proto: $$let$1.to_proto,
      to_proto$p: $$let$1.to_proto$p,
      merge: $$let$1.merge,
      to_json: $$let$1.to_json,
      from_json_exn: $$let$1.from_json_exn,
      from_json: $$let$1.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil)))))))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p(writer, param) {
  Curry.app(serialize, [
    writer,
    param.tin,
    param.org_id,
    param.kkm_id,
    param.order_num,
    param.receipt,
    param.async,
    param.route,
    param.tag,
    param.metadata
  ]);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(tin, org_id, kkm_id, order_num, receipt, async, route, tag, metadata) {
  return {
    tin: tin,
    org_id: org_id,
    kkm_id: kkm_id,
    order_num: order_num,
    receipt: receipt,
    async: async,
    route: route,
    tag: tag,
    metadata: metadata
  };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CreateEtpReceiptRequest", spec(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
      param.tin,
      param.org_id,
      param.kkm_id,
      param.order_num,
      param.receipt,
      param.async,
      param.route,
      param.tag,
      param.metadata
    ]);
  };
}

function constructor$1(tin, org_id, kkm_id, order_num, receipt, async, route, tag, metadata) {
  return {
    tin: tin,
    org_id: org_id,
    kkm_id: kkm_id,
    order_num: order_num,
    receipt: receipt,
    async: async,
    route: route,
    tag: tag,
    metadata: metadata
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CreateEtpReceiptRequest", spec(undefined), constructor$1);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, CreateEtpReceiptRequest, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

function name$1(param) {
  return ".buhta.kassa.v1alpha1.CreateEtpReceiptResponse";
}

function make$1(order, param) {
  return {
    order: order
  };
}

const merge_order = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "order",
    "order"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: EtpOrder.name,
    make: EtpOrder.make,
    from_proto: EtpOrder.from_proto,
    from_proto_exn: EtpOrder.from_proto_exn,
    to_proto: EtpOrder.to_proto,
    to_proto$p: EtpOrder.to_proto$p,
    merge: EtpOrder.merge,
    to_json: EtpOrder.to_json,
    from_json_exn: EtpOrder.from_json_exn,
    from_json: EtpOrder.from_json
  })
]));

function merge$1(t1, t2) {
  return {
    order: Curry._2(merge_order, t1.order, t2.order)
  };
}

function spec$1(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "order",
      "order"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: EtpOrder.name,
      make: EtpOrder.make,
      from_proto: EtpOrder.from_proto,
      from_proto_exn: EtpOrder.from_proto_exn,
      to_proto: EtpOrder.to_proto,
      to_proto$p: EtpOrder.to_proto$p,
      merge: EtpOrder.merge,
      to_json: EtpOrder.to_json,
      from_json_exn: EtpOrder.from_json_exn,
      from_json: EtpOrder.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
});

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.order);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(order) {
  return {
    order: order
  };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
});

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$1, writer);
  });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CreateEtpReceiptResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.order);
  };
}

function constructor$3(order) {
  return {
    order: order
  };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CreateEtpReceiptResponse", spec$1(undefined), constructor$3);
});

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$1, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, CreateEtpReceiptResponse, {
  make: make$1,
  to_proto: to_proto$1,
  from_proto: from_proto$1,
  to_json: to_json$1,
  from_json: from_json$1,
  name: name$1,
  merge: merge$1,
  to_proto$p: to_proto$p$1,
  from_proto_exn: from_proto_exn$1,
  from_json_exn: from_json_exn$1
});

function name$2(param) {
  return ".buhta.kassa.v1alpha1.GetEtpOrderRequest";
}

function make$2(etp_keyOpt, order_numOpt, receipt_num, expandOpt, param) {
  const etp_key = etp_keyOpt !== undefined ? etp_keyOpt : "";
  const order_num = order_numOpt !== undefined ? order_numOpt : "";
  const expand = expandOpt !== undefined ? expandOpt : /* [] */ 0;
  return {
    etp_key: etp_key,
    order_num: order_num,
    receipt_num: receipt_num,
    expand: expand
  };
}

const merge_etp_key = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "etp_key",
    "etpKey"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_order_num$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "order_num",
    "orderNum"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_receipt_num = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    3,
    "receipt_num",
    "receiptNum"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    4,
    "expand",
    "expand"
  ],
  Ocaml_protoc_plugin__Spec.string,
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$2(t1, t2) {
  return {
    etp_key: Curry._2(merge_etp_key, t1.etp_key, t2.etp_key),
    order_num: Curry._2(merge_order_num$1, t1.order_num, t2.order_num),
    receipt_num: Curry._2(merge_receipt_num, t1.receipt_num, t2.receipt_num),
    expand: Curry._2(merge_expand, t1.expand, t2.expand)
  };
}

function spec$2(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "etp_key",
      "etpKey"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "order_num",
      "orderNum"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      3,
      "receipt_num",
      "receiptNum"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      4,
      "expand",
      "expand"
    ],
    Ocaml_protoc_plugin__Spec.string,
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil))));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
});

function to_proto$p$2(writer, param) {
  Curry._5(serialize$2, writer, param.etp_key, param.order_num, param.receipt_num, param.expand);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(etp_key, order_num, receipt_num, expand) {
  return {
    etp_key: etp_key,
    order_num: order_num,
    receipt_num: receipt_num,
    expand: expand
  };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
});

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$2, writer);
  });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetEtpOrderRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._4(serialize, param.etp_key, param.order_num, param.receipt_num, param.expand);
  };
}

function constructor$5(etp_key, order_num, receipt_num, expand) {
  return {
    etp_key: etp_key,
    order_num: order_num,
    receipt_num: receipt_num,
    expand: expand
  };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetEtpOrderRequest", spec$2(undefined), constructor$5);
});

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$2, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetEtpOrderRequest, {
  make: make$2,
  to_proto: to_proto$2,
  from_proto: from_proto$2,
  to_json: to_json$2,
  from_json: from_json$2,
  name: name$2,
  merge: merge$2,
  to_proto$p: to_proto$p$2,
  from_proto_exn: from_proto_exn$2,
  from_json_exn: from_json_exn$2
});

function name$3(param) {
  return ".buhta.kassa.v1alpha1.GetEtpOrderResponse";
}

function make$3(order, param) {
  return {
    order: order
  };
}

const merge_order$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "order",
    "order"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: EtpOrder.name,
    make: EtpOrder.make,
    from_proto: EtpOrder.from_proto,
    from_proto_exn: EtpOrder.from_proto_exn,
    to_proto: EtpOrder.to_proto,
    to_proto$p: EtpOrder.to_proto$p,
    merge: EtpOrder.merge,
    to_json: EtpOrder.to_json,
    from_json_exn: EtpOrder.from_json_exn,
    from_json: EtpOrder.from_json
  })
]));

function merge$3(t1, t2) {
  return {
    order: Curry._2(merge_order$1, t1.order, t2.order)
  };
}

function spec$3(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "order",
      "order"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: EtpOrder.name,
      make: EtpOrder.make,
      from_proto: EtpOrder.from_proto,
      from_proto_exn: EtpOrder.from_proto_exn,
      to_proto: EtpOrder.to_proto,
      to_proto$p: EtpOrder.to_proto$p,
      merge: EtpOrder.merge,
      to_json: EtpOrder.to_json,
      from_json_exn: EtpOrder.from_json_exn,
      from_json: EtpOrder.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
});

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.order);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(order) {
  return {
    order: order
  };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
});

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$3, writer);
  });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetEtpOrderResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.order);
  };
}

function constructor$7(order) {
  return {
    order: order
  };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetEtpOrderResponse", spec$3(undefined), constructor$7);
});

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$3, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetEtpOrderResponse, {
  make: make$3,
  to_proto: to_proto$3,
  from_proto: from_proto$3,
  to_json: to_json$3,
  from_json: from_json$3,
  name: name$3,
  merge: merge$3,
  to_proto$p: to_proto$p$3,
  from_proto_exn: from_proto_exn$3,
  from_json_exn: from_json_exn$3
});

function name$4(param) {
  return ".buhta.kassa.v1alpha1.EtpOrder";
}

function make$4(etp_info, order_numOpt, detailsOpt, receiptsOpt, param) {
  const order_num = order_numOpt !== undefined ? order_numOpt : "";
  const details = detailsOpt !== undefined ? detailsOpt : /* [] */ 0;
  const receipts = receiptsOpt !== undefined ? receiptsOpt : /* [] */ 0;
  return {
    etp_info: etp_info,
    order_num: order_num,
    details: details,
    receipts: receipts
  };
}

const $$let$2 = Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_link.Buhta.Kassa.V1alpha1.EtpInfo;

const merge_etp_info = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "etp_info",
    "etpInfo"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$2.name,
    make: $$let$2.make,
    from_proto: $$let$2.from_proto,
    from_proto_exn: $$let$2.from_proto_exn,
    to_proto: $$let$2.to_proto,
    to_proto$p: $$let$2.to_proto$p,
    merge: $$let$2.merge,
    to_json: $$let$2.to_json,
    from_json_exn: $$let$2.from_json_exn,
    from_json: $$let$2.from_json
  })
]));

const merge_order_num$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "order_num",
    "orderNum"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_details = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.map([
  [
    3,
    "details",
    "details"
  ],
  [
    Ocaml_protoc_plugin__Spec.string,
    Ocaml_protoc_plugin__Spec.basic([
      [
        2,
        "value",
        "value"
      ],
      Ocaml_protoc_plugin__Spec.string,
      ""
    ])
  ]
]));

const merge_receipts = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    4,
    "receipts",
    "receipts"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: EtpReceipt.name,
    make: EtpReceipt.make,
    from_proto: EtpReceipt.from_proto,
    from_proto_exn: EtpReceipt.from_proto_exn,
    to_proto: EtpReceipt.to_proto,
    to_proto$p: EtpReceipt.to_proto$p,
    merge: EtpReceipt.merge,
    to_json: EtpReceipt.to_json,
    from_json_exn: EtpReceipt.from_json_exn,
    from_json: EtpReceipt.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$4(t1, t2) {
  return {
    etp_info: Curry._2(merge_etp_info, t1.etp_info, t2.etp_info),
    order_num: Curry._2(merge_order_num$2, t1.order_num, t2.order_num),
    details: Curry._2(merge_details, t1.details, t2.details),
    receipts: Curry._2(merge_receipts, t1.receipts, t2.receipts)
  };
}

function spec$4(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_link.Buhta.Kassa.V1alpha1.EtpInfo;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "etp_info",
      "etpInfo"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "order_num",
      "orderNum"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.map([
    [
      3,
      "details",
      "details"
    ],
    [
      Ocaml_protoc_plugin__Spec.string,
      Ocaml_protoc_plugin__Spec.basic([
        [
          2,
          "value",
          "value"
        ],
        Ocaml_protoc_plugin__Spec.string,
        ""
      ])
    ]
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      4,
      "receipts",
      "receipts"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: EtpReceipt.name,
      make: EtpReceipt.make,
      from_proto: EtpReceipt.from_proto,
      from_proto_exn: EtpReceipt.from_proto_exn,
      to_proto: EtpReceipt.to_proto,
      to_proto$p: EtpReceipt.to_proto$p,
      merge: EtpReceipt.merge,
      to_json: EtpReceipt.to_json,
      from_json_exn: EtpReceipt.from_json_exn,
      from_json: EtpReceipt.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil))));
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
});

function to_proto$p$4(writer, param) {
  Curry._5(serialize$4, writer, param.etp_info, param.order_num, param.details, param.receipts);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(etp_info, order_num, details, receipts) {
  return {
    etp_info: etp_info,
    order_num: order_num,
    details: details,
    receipts: receipts
  };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
});

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$4, writer);
  });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.EtpOrder", spec$4(undefined))(options);
  return function (param) {
    return Curry._4(serialize, param.etp_info, param.order_num, param.details, param.receipts);
  };
}

function constructor$9(etp_info, order_num, details, receipts) {
  return {
    etp_info: etp_info,
    order_num: order_num,
    details: details,
    receipts: receipts
  };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.EtpOrder", spec$4(undefined), constructor$9);
});

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$4, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, EtpOrder, {
  make: make$4,
  to_proto: to_proto$4,
  from_proto: from_proto$4,
  to_json: to_json$4,
  from_json: from_json$4,
  name: name$4,
  merge: merge$4,
  to_proto$p: to_proto$p$4,
  from_proto_exn: from_proto_exn$4,
  from_json_exn: from_json_exn$4
});

function name$5(param) {
  return ".buhta.kassa.v1alpha1.EtpReceipt";
}

function make$5(receipt, route, tag, metadata, param) {
  return {
    receipt: receipt,
    route: route,
    tag: tag,
    metadata: metadata
  };
}

const $$let$3 = Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt.Buhta.Kassa.V1alpha1.Receipt;

const merge_receipt$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    3,
    "receipt",
    "receipt"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$3.name,
    make: $$let$3.make,
    from_proto: $$let$3.from_proto,
    from_proto_exn: $$let$3.from_proto_exn,
    to_proto: $$let$3.to_proto,
    to_proto$p: $$let$3.to_proto$p,
    merge: $$let$3.merge,
    to_json: $$let$3.to_json,
    from_json_exn: $$let$3.from_json_exn,
    from_json: $$let$3.from_json
  })
]));

const merge_route$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    4,
    "route",
    "route"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const merge_tag$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    5,
    "tag",
    "tag"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const $$let$4 = Google_wkt__Google_protobuf_struct.Google.Protobuf.Struct;

const merge_metadata$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    6,
    "metadata",
    "metadata"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$4.name,
    make: $$let$4.make,
    from_proto: $$let$4.from_proto,
    from_proto_exn: $$let$4.from_proto_exn,
    to_proto: $$let$4.to_proto,
    to_proto$p: $$let$4.to_proto$p,
    merge: $$let$4.merge,
    to_json: $$let$4.to_json,
    from_json_exn: $$let$4.from_json_exn,
    from_json: $$let$4.from_json
  })
]));

function merge$5(t1, t2) {
  return {
    receipt: Curry._2(merge_receipt$1, t1.receipt, t2.receipt),
    route: Curry._2(merge_route$1, t1.route, t2.route),
    tag: Curry._2(merge_tag$1, t1.tag, t2.tag),
    metadata: Curry._2(merge_metadata$1, t1.metadata, t2.metadata)
  };
}

function spec$5(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_receipt.Buhta.Kassa.V1alpha1.Receipt;
  const $$let$1 = Google_wkt__Google_protobuf_struct.Google.Protobuf.Struct;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      3,
      "receipt",
      "receipt"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      4,
      "route",
      "route"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      5,
      "tag",
      "tag"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      6,
      "metadata",
      "metadata"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let$1.name,
      make: $$let$1.make,
      from_proto: $$let$1.from_proto,
      from_proto_exn: $$let$1.from_proto_exn,
      to_proto: $$let$1.to_proto,
      to_proto$p: $$let$1.to_proto$p,
      merge: $$let$1.merge,
      to_json: $$let$1.to_json,
      from_json_exn: $$let$1.from_json_exn,
      from_json: $$let$1.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil))));
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
});

function to_proto$p$5(writer, param) {
  Curry._5(serialize$5, writer, param.receipt, param.route, param.tag, param.metadata);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(receipt, route, tag, metadata) {
  return {
    receipt: receipt,
    route: route,
    tag: tag,
    metadata: metadata
  };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
});

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$5, writer);
  });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.EtpReceipt", spec$5(undefined))(options);
  return function (param) {
    return Curry._4(serialize, param.receipt, param.route, param.tag, param.metadata);
  };
}

function constructor$11(receipt, route, tag, metadata) {
  return {
    receipt: receipt,
    route: route,
    tag: tag,
    metadata: metadata
  };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.EtpReceipt", spec$5(undefined), constructor$11);
});

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$5, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, EtpReceipt, {
  make: make$5,
  to_proto: to_proto$5,
  from_proto: from_proto$5,
  to_json: to_json$5,
  from_json: from_json$5,
  name: name$5,
  merge: merge$5,
  to_proto$p: to_proto$p$5,
  from_proto_exn: from_proto_exn$5,
  from_json_exn: from_json_exn$5
});

const getEtpOrder_0 = {
  name: GetEtpOrderRequest.name,
  make: GetEtpOrderRequest.make,
  from_proto: GetEtpOrderRequest.from_proto,
  from_proto_exn: GetEtpOrderRequest.from_proto_exn,
  to_proto: GetEtpOrderRequest.to_proto,
  to_proto$p: GetEtpOrderRequest.to_proto$p,
  merge: GetEtpOrderRequest.merge,
  to_json: GetEtpOrderRequest.to_json,
  from_json_exn: GetEtpOrderRequest.from_json_exn,
  from_json: GetEtpOrderRequest.from_json
};

const getEtpOrder_1 = {
  name: GetEtpOrderResponse.name,
  make: GetEtpOrderResponse.make,
  from_proto: GetEtpOrderResponse.from_proto,
  from_proto_exn: GetEtpOrderResponse.from_proto_exn,
  to_proto: GetEtpOrderResponse.to_proto,
  to_proto$p: GetEtpOrderResponse.to_proto$p,
  merge: GetEtpOrderResponse.merge,
  to_json: GetEtpOrderResponse.to_json,
  from_json_exn: GetEtpOrderResponse.from_json_exn,
  from_json: GetEtpOrderResponse.from_json
};

const getEtpOrder = [
  getEtpOrder_0,
  getEtpOrder_1
];

const createEtpReceipt_0 = {
  name: CreateEtpReceiptRequest.name,
  make: CreateEtpReceiptRequest.make,
  from_proto: CreateEtpReceiptRequest.from_proto,
  from_proto_exn: CreateEtpReceiptRequest.from_proto_exn,
  to_proto: CreateEtpReceiptRequest.to_proto,
  to_proto$p: CreateEtpReceiptRequest.to_proto$p,
  merge: CreateEtpReceiptRequest.merge,
  to_json: CreateEtpReceiptRequest.to_json,
  from_json_exn: CreateEtpReceiptRequest.from_json_exn,
  from_json: CreateEtpReceiptRequest.from_json
};

const createEtpReceipt_1 = {
  name: CreateEtpReceiptResponse.name,
  make: CreateEtpReceiptResponse.make,
  from_proto: CreateEtpReceiptResponse.from_proto,
  from_proto_exn: CreateEtpReceiptResponse.from_proto_exn,
  to_proto: CreateEtpReceiptResponse.to_proto,
  to_proto$p: CreateEtpReceiptResponse.to_proto$p,
  merge: CreateEtpReceiptResponse.merge,
  to_json: CreateEtpReceiptResponse.to_json,
  from_json_exn: CreateEtpReceiptResponse.from_json_exn,
  from_json: CreateEtpReceiptResponse.from_json
};

const createEtpReceipt = [
  createEtpReceipt_0,
  createEtpReceipt_1
];

const V1alpha1_EtpReceiptService = {
  GetEtpOrder: {
    name: "/buhta.kassa.v1alpha1.EtpReceiptService/GetEtpOrder",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "EtpReceiptService",
    method_name: "GetEtpOrder",
    $$Request: {
      name: GetEtpOrderRequest.name,
      make: GetEtpOrderRequest.make,
      from_proto: GetEtpOrderRequest.from_proto,
      from_proto_exn: GetEtpOrderRequest.from_proto_exn,
      to_proto: GetEtpOrderRequest.to_proto,
      to_proto$p: GetEtpOrderRequest.to_proto$p,
      merge: GetEtpOrderRequest.merge,
      to_json: GetEtpOrderRequest.to_json,
      from_json_exn: GetEtpOrderRequest.from_json_exn,
      from_json: GetEtpOrderRequest.from_json
    },
    $$Response: {
      name: GetEtpOrderResponse.name,
      make: GetEtpOrderResponse.make,
      from_proto: GetEtpOrderResponse.from_proto,
      from_proto_exn: GetEtpOrderResponse.from_proto_exn,
      to_proto: GetEtpOrderResponse.to_proto,
      to_proto$p: GetEtpOrderResponse.to_proto$p,
      merge: GetEtpOrderResponse.merge,
      to_json: GetEtpOrderResponse.to_json,
      from_json_exn: GetEtpOrderResponse.from_json_exn,
      from_json: GetEtpOrderResponse.from_json
    }
  },
  getEtpOrder: getEtpOrder,
  CreateEtpReceipt: {
    name: "/buhta.kassa.v1alpha1.EtpReceiptService/CreateEtpReceipt",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "EtpReceiptService",
    method_name: "CreateEtpReceipt",
    $$Request: {
      name: CreateEtpReceiptRequest.name,
      make: CreateEtpReceiptRequest.make,
      from_proto: CreateEtpReceiptRequest.from_proto,
      from_proto_exn: CreateEtpReceiptRequest.from_proto_exn,
      to_proto: CreateEtpReceiptRequest.to_proto,
      to_proto$p: CreateEtpReceiptRequest.to_proto$p,
      merge: CreateEtpReceiptRequest.merge,
      to_json: CreateEtpReceiptRequest.to_json,
      from_json_exn: CreateEtpReceiptRequest.from_json_exn,
      from_json: CreateEtpReceiptRequest.from_json
    },
    $$Response: {
      name: CreateEtpReceiptResponse.name,
      make: CreateEtpReceiptResponse.make,
      from_proto: CreateEtpReceiptResponse.from_proto,
      from_proto_exn: CreateEtpReceiptResponse.from_proto_exn,
      to_proto: CreateEtpReceiptResponse.to_proto,
      to_proto$p: CreateEtpReceiptResponse.to_proto$p,
      merge: CreateEtpReceiptResponse.merge,
      to_json: CreateEtpReceiptResponse.to_json,
      from_json_exn: CreateEtpReceiptResponse.from_json_exn,
      from_json: CreateEtpReceiptResponse.from_json
    }
  },
  createEtpReceipt: createEtpReceipt
};

const V1alpha1 = {
  CreateEtpReceiptRequest: CreateEtpReceiptRequest,
  CreateEtpReceiptResponse: CreateEtpReceiptResponse,
  GetEtpOrderRequest: GetEtpOrderRequest,
  GetEtpOrderResponse: GetEtpOrderResponse,
  EtpOrder: EtpOrder,
  EtpReceipt: EtpReceipt,
  EtpReceiptService: V1alpha1_EtpReceiptService
};

const Kassa = {
  V1alpha1: V1alpha1
};

const Buhta = {
  Kassa: Kassa
};

export {
  Imported$pmodules,
  Buhta,
}
/* CreateEtpReceiptRequest Not a pure module */
